<template>
	<div :class="classList">
		<div class="card_content">
			<slot></slot>
		</div>
	</div>
</template>

<script type="text/babel">
export default {
	props: {
		title: { default: "" },
		extraClasses: { default: "" },
		type: { default: "regular" }, // regular, outline, highlight
	},

	computed: {
		classList() {
			let classList = "card";

			classList += " " + this.type;

			if (this.extraClasses !== "") {
				classList += " " + this.extraClasses;
			}

			return classList;
		},
	},
};
</script>
